import { render, staticRenderFns } from "./additional-travellers-combined-products-list.vue?vue&type=template&id=7dee73fb&scoped=true"
import script from "./additional-travellers-combined-products-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./additional-travellers-combined-products-list.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./additional-travellers-combined-products-list.vue?vue&type=style&index=0&id=7dee73fb&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dee73fb",
  null
  
)

export default component.exports